import { useLanguage } from './contexts/LanguageContext';

export default function Home() {
	const { t } = useLanguage();
	return (
		<div className='grid grid-rows-[20px_1fr_20px] items-center justify-items-center min-h-screen p-8 pb-20 gap-16 sm:p-20 font-[family-name:var(--font-geist-sans)]'>
			<main className='flex flex-col gap-8 row-start-2 items-center sm:items-start'>
				<h4>{t('contactAdmin')}</h4>
			</main>
		</div>
	);
}
